import Vue from "vue";
import { API_ROOT, studyManagement, users, forgotPassword, verify, invite, profile, searchusers, sortusers, studies, associateUser, disassociateUser, search, user, signout, notification, unReadCount, API_ROOT_V2, COGNITO_API_US_WEB_ROOT, checkUsername, register, clients, importuserscsv, downloadusertemplate, sites } from "./urls";

const usersResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}`, {}, { update: { method: "PUT" } });
const usersSearchResource = Vue.resource(`${API_ROOT}${studyManagement}${users}/${searchusers}`, {}, { update: { method: "PUT" } });
const usersPasswordResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${forgotPassword}`, {}, { update: { method: "PUT" } });
const userImportResource = Vue.resource(`${API_ROOT}${studyManagement}${importuserscsv}`, {}, { update: { method: "PUT" } });
const userDownloadTemplateResource = Vue.resource(`${API_ROOT}${studyManagement}${downloadusertemplate}`, {}, { update: { method: "PUT" } });
const usersVerifyResource = Vue.resource(`${API_ROOT}${studyManagement}${users}/${verify}`, {}, { update: { method: "PUT" } });
const usersInviteResource = Vue.resource(`${API_ROOT}${studyManagement}${users}/${invite}`, {}, { update: { method: "PUT" } });
const userDetailsResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${profile}`, {}, { update: { method: "PUT" } });
const studyUsersResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}`, {}, { update: { method: "PUT" } });
const associateResource = Vue.resource(`${API_ROOT_V2}${studyManagement}${studies}/{studyId}/${users}/${associateUser}`, {}, { update: { method: "PUT" } });
const disassociateResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}/${disassociateUser}`, {}, { update: { method: "PUT" } });
const searchResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}/${search}`, {}, { update: { method: "PUT" } });
const resendInviteResource = Vue.resource(`${API_ROOT}${studyManagement}${user}/${invite}`, {}, { update: { method: "POST" } });

const logUserLogoutResource = Vue.resource(`${API_ROOT}${studyManagement}${users}{/userId}/${signout}`);

const configureUnreadCount = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}{/userId}/${notification}/${unReadCount}`, {}, { update: { method: "PUT" } });

const getUsersResource = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}`, {}, { update: { method: "PUT" } });

const instantUserDataFactResource = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}{/userId}?studyId={studyId}`, {}, { update: { method: "PUT" } });

const usersFilterResource = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}/${sortusers}`, {}, { update: { method: "PUT" } });

const studyDisassociateResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}/${disassociateUser}`, {}, { update: { method: "PUT" } });

const studyAssociateResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${users}/${associateUser}`, {}, { update: { method: "PUT" } });

const checkUsernameResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${checkUsername}`, {});

const registerUserResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${user}/${register}`, {});

const userDeactivationResource = Vue.resource(`${API_ROOT}${studyManagement}${clients}/{clientId}`, {}, { update: { method: "PUT" } });

const dataAccessResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}/{studyId}/${user}/{userId}/data/access/type?userDataAccessType={dataAccessType}`, {}, { update: { method: "PUT" } });

const saveSiteAssignments = Vue.resource(`${API_ROOT_V2}${studyManagement}${users}{/userId}/${sites}`, {});

export function getAllUsersFact() {
  return usersResource.get();
}

export function userSearchFilterFact(searchterm, sort, filter, hideDeactivatedUser) {
  return usersFilterResource.get({
    search: searchterm,
    sort,
    filter,
    hideDeactivatedUser
  });
}

export function searchUsersFact(searchTerm) {
  return usersSearchResource.get({ username: searchTerm });
}

export function getUserDataFact(userId) {
  return usersResource.get({ userId });
}

export function importUserDataFact(data) {
  return userImportResource.save(data);
}

export function downloadTemplateUserDataFact() {
  return userDownloadTemplateResource.get();
}

export function addNewUserInfoFact(data) {
  return usersResource.save(data);
}

export function verifyUserInfoFact(data) {
  return usersVerifyResource.save(data);
}

export function inviteUserInfoFact(data) {
  return usersInviteResource.save(data);
}

export function updateUserInfoFact(userId, data) {
  return usersResource.update({ userId }, data);
}

export function passwordUserInfoFact(userId) {
  return usersPasswordResource.update({ userId }, {});
}

export function userDetailsFact(userId, data) {
  return userDetailsResource.update({ userId }, data);
}

export function getStudyUsersFact(studyId, type, associated) {
  return studyUsersResource.get({ studyId, type, associated });
}

export function userAssociateFact(studyId, data) {
  return associateResource.save({ studyId }, data);
}

export function userDisassociateFact(studyId, data) {
  return disassociateResource.update({ studyId }, data);
}

export function searchUserFact(studyId, type, associated, searchterm) {
  return searchResource.get({ studyId, type, associated, search: searchterm });
}

export function resendInviteFact(id, data) {
  return resendInviteResource.update({ id }, data);
}

export function logUserlogoutFact(userId) {
  return logUserLogoutResource.save({ userId }, {});
}

export function getUnreadCount(studyId, userId) {
  return configureUnreadCount.get({ studyId, userId }, {});
}

export function getAllInstantUsersFact(queryParams) {
  return getUsersResource.get(queryParams);
}

export function getInstantUserDataFact(userId, studyId = "") {
  return instantUserDataFactResource.get({ userId, studyId });
}

export function studyTeamDisassociateFact(studyId, data) {
  return studyDisassociateResource.update({ studyId }, data);
}

export function studyTeamAssociateFact(studyId, data) {
  return studyAssociateResource.save({ studyId }, data);
}

export function checkUsernameAvailability(data) {
  return checkUsernameResource.save(data);
}

export function registerUser(data) {
  return registerUserResource.save(data);
}

export function userDeactivation(clientId, isUserDeactivationConfigured, data) {
  return userDeactivationResource.update({ clientId, isUserDeactivationConfigured }, data);
}

export function getUserSettingsFact(clientId) {
  return userDeactivationResource.get({ clientId });
}

export function updateDataAccessFact(studyId, userId, dataAccessType) {
  return dataAccessResource.update({ studyId, userId, dataAccessType }, {});
}

export function saveUpdateSiteAssignments(pathParams, queryparam, postData) {
  const data = { ...pathParams, ...queryparam };
  return saveSiteAssignments.save(data, postData);
}